module.exports = __webpack_public_path__ + "img/9788961701181.e987993d.jpg";